import React, { Fragment, useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Select from "react-select";
//impoertacion componentes

import {
  creaInstitucion,
  obtenerDepartamento,
  obtenerMunicipio,
  obtenerTipoInstitucion,
} from "../../Services/Rest";
import PerfilAutoevaluacio from "./PerfilAutoevaluacion";
import Cookie from "universal-cookie";
import CopyInstitucion from "./InstitucionAdmin";

function CreaInstitucion() {
  const cookie = new Cookie();
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const [selectedOptions1, setSelectedOptions1] = useState([]);
  const [options1, setOptions1] = useState([]);
  const [municipio, setMunicipio] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: obtenerMunicipio,
    })
      .then((Response) => {
        const apiOptions1 = Response.data.map((item) => ({
          value: item.id,
          label: item.municipio,
        }));
        setOptions1(apiOptions1);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const [departamento, setDepartamento] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [options, setOptions] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: obtenerDepartamento,
    })
      .then((Response) => {
        const apiOptions = Response.data.map((item) => ({
          value: item.id,
          label: item.departamento,
        }));
        setOptions(apiOptions);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setDepartamento]);

  const [tipoInstitucion, setTipoInstitucion] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: obtenerTipoInstitucion,
    })
      .then((Response) => {
        setTipoInstitucion(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setTipoInstitucion]);

  const [postRazonSocial, setPostRazonSocial] = useState([]);
  const [postNit, setPostNit] = useState([]);
  const [postTipoInstitucion, setPostTipoInstitucion] = useState([]);
  const [postEspecialidad, setPostEspecialidad] = useState([]);
  const [postDireccion, setPostDireccion] = useState([]);
  const [postCiudad, setPostMunicipio] = useState([]);
  const [postDepartamento, setPostDepartamento] = useState([]);
  const [postFechaAcreditacion, setPostFechaAcreditacion] = useState([]);
  const [postFechaRenovacion, setPostFechaRenovacion] = useState([]);
  const [postCorreo, setPostCorreo] = useState([]);
  const [postCodigo, setPostCodigo] = useState([]);
  const [postTelefono, setPostTelefono] = useState([]);
  const [postMision, setPostMision] = useState([]);
  const [postVision, setPostVision] = useState([]);
  const [postPrincipios, setPostPrincipios] = useState([]);
  const [postValores, setPostValores] = useState([]);
  const [postObjetivosEstrategicos, setPostObjetivosEstrategicos] = useState(
    [],
  );
  const [postPolitica, setPostPolitica] = useState([]);

  const postData = (e) => {
    e.preventDefault(e);
    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/CreaInstitucion",
      data: {
        Razon_Social: postRazonSocial,
        Nit: postNit,
        Direccion: postDireccion,
        Tipo_Institucion: postTipoInstitucion,
        Especialidad: "na",
        Ciudad: selectedOptions1.label,
        Departamento: selectedOptions.label,
        fecha_acreditacion: postFechaAcreditacion,
        fecha_renovacion: postFechaRenovacion,
        correo: postCorreo,
        codigo_prestador: postCodigo,
        telefono: postTelefono,
        estado: "activo",
        mision: postMision + "",
        vision: postVision + "",
        principios: postPrincipios + "",
        valores: postValores + "",
        objetivosEstrategicos: postObjetivosEstrategicos + "",
        politicaSeguridad: postPolitica + "",
      },
    })
      .then((Response) => {
        console.log(Response.data);
        alert("Institucion creada con exito!");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear Institucion");
      });
  };

  return (
    <div className="test">
      <div className="container">
        <div className="text-center">
          <div class="container-fluid">
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">
                  Crear Institucion
                </h6>
                <br></br>
                {cookie.get("tipo_Usuario") == 1 ? (
                  <CopyInstitucion />
                ) : (
                  <h1></h1>
                )}
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <form className="user">
                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <input
                          type="text"
                          className="form-control form-control-user"
                          placeholder="Razón social"
                          onChange={(e) => setPostRazonSocial(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control form-control-user"
                        placeholder="Nit"
                        onChange={(e) => setPostNit(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <input
                          type="text"
                          className="form-control form-control-user"
                          placeholder="Direccion"
                          onChange={(e) => setPostDireccion(e.target.value)}
                          required
                        />
                      </div>
                      <div className="col-sm-6">
                        <select
                          className="btn btn-secondary btn-user btn-block"
                          onChange={(e) =>
                            setPostTipoInstitucion(e.target.value)
                          }
                          required
                        >
                          <option value="">Tipo Institucion</option>
                          {tipoInstitucion.map((item) => (
                            <option value={item.id}>{item.tipo}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        Seleccione el municipio
                        <Select
                          name="colors"
                          options={options1}
                          classNamePrefix="select"
                          onChange={(selected) => setSelectedOptions1(selected)}
                        />
                        <select
                          className="btn btn-secondary btn-user btn-block"
                          onChange={(e) => setPostMunicipio(e.target.value)}
                          required
                          hidden
                        >
                          <option value="">Seleccione municipio</option>
                          {municipio.map((item) => (
                            <option value={item.id}>{item.municipio}</option>
                          ))}
                        </select>
                      </div>
                      <div className="col-sm-6">
                        Seleccione el Departamento
                        <Select
                          name="colors"
                          options={options}
                          classNamePrefix="select"
                          onChange={(selected) => setSelectedOptions(selected)}
                        />
                        <select
                          className="btn btn-secondary btn-user btn-block"
                          onChange={(e) => setPostDepartamento(e.target.value)}
                          required
                          hidden
                        >
                          <option value="">Seleccione Departamento</option>
                          {departamento.map((item) => (
                            <option value={item.id}>{item.departamento}</option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        Fecha acreditacion
                        <input
                          type="date"
                          className="form-control form-control-user"
                          placeholder="acreditacion"
                          onChange={(e) =>
                            setPostFechaAcreditacion(e.target.value)
                          }
                          required
                        />
                      </div>
                      <div className="col-sm-6">
                        Fecha renovacion
                        <input
                          type="date"
                          className="form-control form-control-user"
                          placeholder="Renovacion"
                          onChange={(e) =>
                            setPostFechaRenovacion(e.target.value)
                          }
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control form-control-user"
                        placeholder="correo"
                        onChange={(e) => setPostCorreo(e.target.value)}
                        required
                      />
                    </div>
                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <input
                          type="text"
                          className="form-control form-control-user"
                          placeholder="codigo"
                          onChange={(e) => setPostCodigo(e.target.value)}
                          required
                        />
                      </div>
                      <div className="col-sm-6">
                        <input
                          type="text"
                          className="form-control form-control-user"
                          placeholder="telefono"
                          onChange={(e) => setPostTelefono(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    {cookie.get("tipo_Usuario") == 2 ? (
                      <p>
                        <div className="form-group row">
                          <div className="col-sm-12">
                            <label for="exampleFormControlTextarea1">
                              Misión
                            </label>
                            <textarea
                              className="form-control"
                              id="exampleFormControlTextarea1"
                              rows="6"
                              onChange={(e) => setPostMision(e.target.value)}
                              required
                            ></textarea>{" "}
                          </div>
                        </div>
                        <div className="form-group row">
                          <div className="col-sm-12">
                            <label for="exampleFormControlTextarea1">
                              Visión
                            </label>
                            <textarea
                              className="form-control"
                              id="exampleFormControlTextarea1"
                              rows="6"
                              onChange={(e) => setPostVision(e.target.value)}
                              required
                            ></textarea>{" "}
                          </div>
                        </div>
                        <div className="col-md-12">
                          <label for="exampleFormControlTextarea1">
                            Principios
                          </label>
                          <textarea
                            className="form-control"
                            id="exampleFormControlTextarea1"
                            rows="6"
                            onChange={(e) => setPostPrincipios(e.target.value)}
                            required
                          ></textarea>
                        </div>
                        <div className="col-md-12">
                          <label for="exampleFormControlTextarea1">
                            Valores
                          </label>
                          <textarea
                            className="form-control"
                            id="exampleFormControlTextarea1"
                            rows="6"
                            onChange={(e) => setPostValores(e.target.value)}
                            required
                          ></textarea>
                        </div>
                        <div className="col-md-12">
                          <label for="exampleFormControlTextarea1">
                            Politica de seguridad y salud trabajo
                          </label>
                          <textarea
                            className="form-control"
                            id="exampleFormControlTextarea1"
                            rows="6"
                            onChange={(e) => setPostPolitica(e.target.value)}
                            required
                          ></textarea>
                        </div>
                        <div className="col-md-12">
                          <label for="exampleFormControlTextarea1">
                            Objetivos Estrategicos
                          </label>
                          <textarea
                            className="form-control"
                            id="exampleFormControlTextarea1"
                            rows="6"
                            onChange={(e) =>
                              setPostObjetivosEstrategicos(e.target.value)
                            }
                            required
                          ></textarea>
                        </div>
                      </p>
                    ) : (
                      <h1></h1>
                    )}
                    <a>
                      <button
                        className="btn btn-primary btn-user btn-block"
                        onClick={postData}
                      >
                        Guardar
                      </button>
                    </a>
                    <hr />
                  </form>
                </div>
              </div>
              {cookie.get("tipo_Usuario") == 2 ? (
                <PerfilAutoevaluacio />
              ) : (
                <h1></h1>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default CreaInstitucion;
